import PageWrapper from "components/PageWrapper";
import UserRolesTable from "./user-roles-table";

function UserRoles() {
  return (
    <PageWrapper>
      <UserRolesTable />
    </PageWrapper>
  );
}

export default UserRoles;
